export {
	getIconTypes,
	flattenIconsArray,
	simplifyCategories,
} from './icon-functions';
export { parseIcon } from './parse-icon';
export {
	parseUploadedMediaAndSetIcon,
	parseDroppedMediaAndSetIcon,
} from './parse-media';
export { displayMessages } from './display-messages';
